import PropTypes from 'prop-types';

import Gap from 'bloko/blocks/gap';

import 'components/ClickmeFormWrapper/ClickmeFormWrapper.less';

const ClickmeFormWrapper = ({ children }) => (
    <Gap bottom>
        <div className="clickme-form-wrapper">{children}</div>
    </Gap>
);

ClickmeFormWrapper.propTypes = {
    children: PropTypes.node,
};

export default ClickmeFormWrapper;
